<template>
    <feathers-vuex-find service="users-permissions" :query="{ user_id: item.id }" watch="query">
        <v-dialog v-model="dialog" width="500" persistent scrollable slot-scope="{ items: Permissions, isFindPending }">
            <template v-slot:activator="{ on, attrs }">
                <v-btn small color="green" rounded dark v-bind="attrs" v-on="on">
                    <v-icon left>mdi-cog</v-icon>
                    Manage Options
                </v-btn>
            </template>
            <v-data-transformer :data-array="Permissions" :transform="dataTransform">
                <v-card slot-scope="{ data: Info }">
                    <v-card-title>
                        Manage {{ [item.fname, item.lname].join(' ') }} Options
                    </v-card-title>
                    <v-card-text style="text-align: center;">
                        <v-row v-if="!isFindPending">
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.publish" label="Publish"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.verified" label="Verified User"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.searchable" label="Searchable"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.group_messaging" label="Group Messaging"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.report_messaging" label="Report Messaging"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.report_filtering" label="Report Filtering"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.geomap" label="Geomap Reporting"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.token_campaign_enabled" label="Token Campaign Enabled"></v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-checkbox v-model="Info.token_campaign_listed" label="Token Campaign Listed"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-progress-circular v-else :size="50" color="primary" indeterminate></v-progress-circular>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!loading" small color="red" text @click="dialog = false">Cancel</v-btn>
                        <v-btn small color="primary" text @click="save(Info)" :loading="loading">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-data-transformer>
        </v-dialog>
    </feathers-vuex-find>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            rolesValue: this.item.roles.map(i => i.role.id)
        };
    },
    // async mounted() {
    //     try {
    //         const permissions = await this.getPermissions({ query: { user_id: this.item.id } }).then(result => {
    //             if(result.length !== 0) {
    //                 return result[0];
    //             } else {
    //                 return {

    //                 }
    //             }
    //         });
    //     } catch(err) {
    //         console.log(err);
    //     }
    // },
    methods: {
        async save(item) {
            try {
                this.loading = true;
                item.user_id = this.item.id;
                await item.update();
                this.dialog = false;
                this.$emit('success');
            } catch(err) {
                console.log(err);
                this.$emit('error', err);
            } finally {
                this.loading = false;
            }
        },
        dataTransform(data) {
            const self = this;
            if(data.length !== 0) {
                return data[0];
            } else {
                return {
                    user_id: this.item.id,
                    geomap: 0,
                    verified: 0,
                    report_filtering: 0,
                    group_messaging: 0,
                    report_messaging: 0,
                    publish: 1,
                    searchable: 1,
                    token_campaign_enabled: 0,
                    token_campaign_listed: 0,
                    update() {
                        return self.createNewPermissions(this);
                    }
                };
            }
        },
        ...mapActions('bh-user-roles', { createNewRoles: 'create', removeRoles: 'remove' }),
        ...mapActions('users', { findUser: 'find' }),
        ...mapActions('users-permissions', { getPermissions: 'find', createNewPermissions: 'create' })
    }
}; 
</script>